import configs from 'configs';

const getDocumentDirection = () => document.dir || configs.directions.ltr;

export default getDocumentDirection;
